import { render, staticRenderFns } from "./PracticeDocuments.vue?vue&type=template&id=e2d02d40"
import script from "./PracticeDocuments.vue?vue&type=script&lang=js"
export * from "./PracticeDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports